import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from "@angular/core";
import {
  AuthConfig,
  OAuthModule,
  OAuthModuleConfig,
  OAuthStorage,
} from "angular-oauth2-oidc";
import { authModuleConfig } from "./auth-module.config";
import { authConfig } from "./auth.config";
import { AuthenticationService } from "./shared/services/authentication.service";
import { AuthGuard } from "./guards/auth.guard";
import { RoleGuard } from "./guards/role.guard";
import { CapabilityGuard } from "./guards/capability.guard";

// We need a factory since localStorage is not available at AOT build time
export function storageFactory(): OAuthStorage {
  return localStorage;
}

@NgModule({ imports: [OAuthModule.forRoot()], providers: [AuthenticationService, AuthGuard, RoleGuard, CapabilityGuard, provideHttpClient(withInterceptorsFromDi())] })
export class AppAuthModule {
  constructor(@Optional() @SkipSelf() parentModule?: AppAuthModule) {
    if (parentModule) {
      throw new Error(
        "AuthModule is already loaded. Import it in the AppModule only"
      );
    }
  }

  static forRoot(): ModuleWithProviders<AppAuthModule> {
    return {
      ngModule: AppAuthModule,
      providers: [
        AuthenticationService,
        { provide: AuthConfig, useValue: authConfig },
        { provide: OAuthModuleConfig, useValue: authModuleConfig },
        { provide: OAuthStorage, useFactory: storageFactory },
      ],
    };
  }

  static forChild(): ModuleWithProviders<AppAuthModule> {
    return {
      ngModule: AppAuthModule,
      providers: [AuthenticationService],
    };
  }
}
